import * as React from "react"
import { Input } from "@digits-shared/DesignSystem/FormElements/Input"
import { type PrimitiveAtom, useAtom } from "jotai"
import {
  InputGroup,
  PanelLabel,
} from "src/frontend/components/OS/Applications/CategoryManager/CategoryPanel/Shared"

interface CategoryNameInputProps {
  categoryNameAtom: PrimitiveAtom<string>
  isNameUnique: boolean
}

export const CategoryNameInput: React.FC<CategoryNameInputProps> = ({
  categoryNameAtom,
  isNameUnique,
}) => {
  const [categoryName, setCategoryName] = useAtom(categoryNameAtom)
  const [hintText, setHintText] = React.useState<string | undefined>(undefined)

  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setCategoryName(e.target.value)
    },
    [setCategoryName]
  )

  React.useEffect(() => {
    if (!isNameUnique) {
      setHintText("Note: This category name already exists. We suggest entering a different name.")
    } else {
      setHintText(undefined)
    }
  }, [isNameUnique])

  return (
    <InputGroup>
      <PanelLabel>Category Name</PanelLabel>

      <Input
        name="categoryName"
        placeholder="ex. Travel"
        value={categoryName}
        onChange={onChange}
        helpText={hintText}
      />
    </InputGroup>
  )
}
